import type { CSSProperties, ReactNode } from 'react';

export interface IGrid {
    tag?: string;
    className?: string;
    children?: ReactNode;
    fluid?: boolean;
    fixed?: boolean;
    scrollable?: boolean;
    xs?: number | string;
    sm?: number | string;
    md?: number | string;
    lg?: number | string;
    xl?: number | string;
    style?: CSSProperties;
}

export const propTypes = ['xs', 'fluid', 'scrollable', 'fixed', 'sm', 'md', 'lg', 'xl', 'style'];
